// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';

import Dialog from 'components/common/Dialog';

const ErrorModal = ({
  isOpen,
  title,
  message,
  onCancel,
  onRetry,
  positiveCTA,
  negativeCTA,
}) => (
  <Dialog
    isOpen={isOpen}
    title={title}
    message={message}
    positiveCTA={positiveCTA || 'Retry'}
    onPositive={onRetry}
    negativeCTA={negativeCTA || 'Cancel'}
    onNegative={onCancel}
    // We allow for injection here since all of our
    // error messaging is local (for now)
    injectHtml
  />
);

ErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  onCancel: PropTypes.func,
  onRetry: PropTypes.func,
  positiveCTA: PropTypes.string,
  negativeCTA: PropTypes.string,
};

ErrorModal.defaultProps = {
  title: '',
  message: '',
  onRetry: null,
  onCancel: null,
  positiveCTA: null,
  negativeCTA: null,
};

export default ErrorModal;
